module.exports = __webpack_public_path__ + "img/logo-foz-chapeco.25be113f.png";